module.exports = global.config = {
    links: {
        discord: "https://discord.gg/sQnNq3Umfz",
        twitter: "https://twitter.com/EtherFrens",
        opensea: "https://opensea.io/collection/etherfrens"
    }
};